// Common
import config from '@/config.js'

let showLocaleChange = true // 是否显示语言切换按钮

// let baseURL = "http://api.new.com/";// 本地测试环境接口域名
// let reportURL =
//   'http://localhost:8081/#/from-happylike/' +
//   encodeURIComponent('http://api.new.com') +
//   '/'; // 本地测试环境接口域名
// let fengpuURL = 'https://fpapi.e-agency-china.top/' // 蜂铺接口域名
let fengpuURL = 'https://api.fengputech.cn/' // 蜂铺接口域名
let baseURL = 'https://branch.api.v1.yywd.vip/' // 云端测试环境接口域名
let adminUrl = 'https://test.admin.api.yywd.vip/' // 云端测试环境接口域名
let shopPsiUrl = 'https://test.shop.psi.yywd.vip/#/from-admin/http%3A%2F%2Ftest.api.v1.yywd.vip/' // 云端测试环境域名
let reportURL =
  'https://test.report.yywd.vip/#/from-happylike/' +
  encodeURIComponent('http://test.api.v1.yywd.vip') +
  '/'; // 云端测试环境域名
let logoFolder = '';
// let baseURL = "https://huawei.api.v1.yywd.vip/";// 华为云端测试环境接口域名
if (window.location.host.startsWith('admin.yywd.vip')) {
  config.debug = false
  baseURL = 'https://api.v1.yywd.vip/' // 生产环境接口域名  
  adminUrl = 'https://admin.api.yywd.vip/' // 生产环境api_base接口域名
  shopPsiUrl = 'https://shop.psi.yywd.vip/#/from-admin/https%3A%2F%2Fapi.v1.yywd.vip/' // 生产环境域名
  reportURL =
    'https://report.yywd.vip/#/from-happylike/' +
    encodeURIComponent(baseURL) +
    '/';
  showLocaleChange = false // 生产环境不显示语言切换按钮
} else if (window.location.host.startsWith('adminvue.jicainiao.com')) {
  config.debug = false
  baseURL = 'https://admin.jicainiao.com/' // 三联独立部署接口域名
  adminUrl = 'https://admin.api.yywd.vip/' // 生产环境api_base接口域名
  reportURL =
    'https://report.jicainiao.com/#/from-happylike/' +
    encodeURIComponent(baseURL) +
    '/';
  showLocaleChange = false // 生产环境不显示语言切换按钮
} else if (window.location.host.startsWith('adminvue2.jicainiao.com')) {
  config.debug = false
  baseURL = 'https://admin2.jicainiao.com/' // 三联独立部署接口域名
  adminUrl = 'https://admin.api.yywd.vip/' // 生产环境api_base接口域名
  reportURL =
    'https://report.jicainiao.com/#/from-happylike/' +
    encodeURIComponent(baseURL) +
    '/';
  showLocaleChange = false // 生产环境不显示语言切换按钮
} else if (window.location.host.startsWith('guadou.admin.yywd.vip')) {
  config.debug = false
  baseURL = 'https://guadou.api.v1.yywd.vip/' // 合肥瓜豆独立部署接口域名
  adminUrl = 'https://admin.api.yywd.vip/' // 生产环境api_base接口域名
  reportURL =
    'https://guadou.report.yywd.vip/#/from-happylike/' +
    encodeURIComponent(baseURL) +
    '/';
  showLocaleChange = false // 生产环境不显示语言切换按钮
// } else if (window.location.host.startsWith('wms.admin.fengputech.cn')) {
//   config.debug = false
//   baseURL = 'https://wms.api.fengputech.cn/' // 蜂铺独立部署接口域名  
//   reportURL =
//     'https://wms.report.fengputech.cn/#/from-happylike/' +
//     encodeURIComponent(baseURL) +
//     '/';
//   showLocaleChange = false // 生产环境不显示语言切换按钮
//   logoFolder = 'fengputech/'//自定义logo文件夹
} else if (window.location.host.startsWith('test.admin.yywd.vip')) {
  config.debug = false
  // axios.defaults.baseURL = "https://test.api.v1.yywd.vip/";// 云端测试环境接口域名
  baseURL = 'https://test.api.v1.yywd.vip/' // 云端测试环境接口域名  
  adminUrl = 'https://test.admin.api.yywd.vip/' // 测试环境api_base接口域名
  shopPsiUrl = 'https://test.shop.psi.yywd.vip/#/from-admin/http%3A%2F%2Ftest.api.v1.yywd.vip/' // 测试环境域名
  reportURL =
    'https://test.report.yywd.vip/#/from-happylike/' +
    encodeURIComponent('http://test.api.v1.yywd.vip') +
    '/';
} else if (window.location.host.startsWith('branch.admin.yywd.vip')) {
  config.debug = false
  // axios.defaults.baseURL = "https://branch.api.v1.yywd.vip/";// 云端测试环境接口域名
  baseURL = 'https://branch.api.v1.yywd.vip/' // 云端测试环境接口域名  
  adminUrl = 'https://branch.admin.api.yywd.vip/' // 测试环境api_base接口域名
  shopPsiUrl = 'https://branch.shop.psi.yywd.vip/#/from-admin/http%3A%2F%2Fbranch.api.v1.yywd.vip/' // 测试环境域名
  reportURL =
    'https://branch.report.yywd.vip/#/from-happylike/' +
    encodeURIComponent('http://branch.api.v1.yywd.vip') +
    '/';
} else if (window.location.host.startsWith('beta.admin.yywd.vip')) {
  config.debug = false
  // axios.defaults.baseURL = "https://beta.api.v1.yywd.vip/";// 云端测试环境接口域名
  baseURL = 'https://beta.api.v1.yywd.vip/' // 云端测试环境接口域名  
  adminUrl = 'https://beta.admin.api.yywd.vip/' // tmp测试环境api_base接口域名
  shopPsiUrl = 'https://beta.shop.psi.yywd.vip/#/from-admin/http%3A%2F%2Fbeta.api.v1.yywd.vip/' // tmp测试环境域名
  reportURL =
    'https://beta.report.yywd.vip/#/from-happylike/' +
    encodeURIComponent('https://beta.api.v1.yywd.vip') +
    '/';
} else if (window.location.host.startsWith('tmp.admin.yywd.vip')) {
  config.debug = false
  // axios.defaults.baseURL = "https://tmp.api.v1.yywd.vip/";// 云端测试环境接口域名
  baseURL = 'http://tmp.api.v1.yywd.vip/' // 云端测试环境接口域名  
  adminUrl = 'http://tmp.admin.api.yywd.vip/' // tmp测试环境api_base接口域名
  shopPsiUrl = 'https://tmp.shop.psi.yywd.vip/#/from-admin/http%3A%2F%2Ftmp.api.v1.yywd.vip/' // tmp测试环境域名
  reportURL =
    'http://tmp.report.yywd.vip/#/from-happylike/' +
    encodeURIComponent('http://tmp.api.v1.yywd.vip') +
    '/';
}

const Headers = {
  debug: false, //for test
  'request-from': 'AdminFront'
}

export default {
  LogoFolder: logoFolder,
  FengpuURL: fengpuURL,
  BaseURL: baseURL,
  AdminUrl: adminUrl,
  ShopPsiUrl: shopPsiUrl,
  ReportURL: reportURL,
  Headers,
  showLocaleChange: showLocaleChange
}
